import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CategoryItemType } from '../api/getCategories';
import { IHelpCenterState } from './types';

const initialState: IHelpCenterState = {
  currentCategory: null,
  currentArticle: null,
  currentArticleLoading: false,
  categories: [],
  normalizedCategories: {},
  articleHeadingVisible: false,
  fullPageSidebarOpened: false,
  fullPageSidebarExtended: false,
};

const getNormalizedCategories = (
  categories: CategoryItemType[],
): Record<CategoryItemType['id'], CategoryItemType> => {
  let categoriesRecord: Record<CategoryItemType['id'], CategoryItemType> = {};

  (categories ?? []).forEach((category) => {
    categoriesRecord[category.id] = category;

    if (category.children) {
      categoriesRecord = {
        ...categoriesRecord,
        ...getNormalizedCategories(category.children),
      };
    }
  });

  return categoriesRecord;
};

export const helpCenterSlice = createSlice({
  name: 'helpCenter',
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload ?? [];
      state.normalizedCategories = getNormalizedCategories(action.payload);
    },
    setCurrentCategory: (state, action) => {
      state.currentArticle = null;
      state.currentCategory = action.payload;
    },
    setCurrentArticle: (state, action) => {
      state.currentCategory = null;
      state.currentArticle = action.payload;
    },
    setCurrentArticleLoading: (state, action) => {
      state.currentArticleLoading = action.payload;
    },
    setArticleHeadingVisible: (state, action) => {
      state.articleHeadingVisible = action.payload;
    },
    setSidebarOpened: (state, action: PayloadAction<boolean>) => {
      state.fullPageSidebarOpened = action.payload;
    },
    setSidebarExtended: (state, action: PayloadAction<boolean>) => {
      state.fullPageSidebarExtended = action.payload;
    },
  },
});
